import { getSelectedShippingMethod, isBlockCheckout, getSelectedShippingMethodForSubscription, dateYmdToFormattedDate, getSetting } from "../common/helper"
import { SUBSCRIPTIONS_EXTENSION_SLUG } from "./constants";
import { SUBSCRIPTIONS_STORE_NAME as STORE_NAME } from "../constants";
import SubscriptionProductType from "../valueObject/SubscriptionProductType";

/**
 * Common helper functions to update the checkout for both the classic and block checkout.
 */
export const updateCheckout = () => {
	// Classic checkout.
	if ( !isBlockCheckout() ) {
		jQuery( document.body ).trigger( 'update_checkout' );
		return;
	}

	// Block checkout.
	const { extensionCartUpdate } = wc.blocksCheckout;

	const regularDateYmd = wp.data.select(STORE_NAME).getDateYmd(SubscriptionProductType.REGULAR);
	const subscriptionDateYmd = wp.data.select(STORE_NAME).getDateYmd(SubscriptionProductType.SUBSCRIPTION);
	const formattedRegularDate = dateYmdToFormattedDate(regularDateYmd);
	const formattedSubscriptionDate = dateYmdToFormattedDate(subscriptionDateYmd);

	extensionCartUpdate( {
		namespace: SUBSCRIPTIONS_EXTENSION_SLUG,
		data: {
			regular: {
				date: formattedRegularDate,
				date_ymd: regularDateYmd,
				timeslot: wp.data.select( STORE_NAME ).getTimeslot( SubscriptionProductType.REGULAR ),
				shipping_method: getSelectedShippingMethod(0)
			},
			subscription: {
				date: formattedSubscriptionDate,
				date_ymd: subscriptionDateYmd,
				timeslot: wp.data.select( STORE_NAME ).getTimeslot( SubscriptionProductType.SUBSCRIPTION ),
				shipping_method: getSelectedShippingMethodForSubscription()
			}
		},
	} );
}

export const isDeliverySlotsEnabledForShippingMethod = (shippingMethod) => {
	const shippingMethodSettings = getSetting('general_setup_shipping_methods');

	if ( shippingMethodSettings.includes('any') ) {
		return true;
	}

	return shippingMethodSettings.includes(shippingMethod);
}

/**
 * Check if previously selected date is still bookable after shipping method change.
 * 
 * @param {string} type
 * @param {Array} bookableDates
 * @return {boolean}
 */
export const isDateBookable = (type, bookableDates) => {
	if (!bookableDates) {
		return false;
	}

	const dateYmd = wp.data.select(STORE_NAME).getDateYmd(type);
	return bookableDates?.some(date => date.ymd === dateYmd);
}

/**
 * Calculate the maximum date based on the subscription interval and period.
 * 
 * @return {Date}
 */
export const getMaxDate = () => {
	const maxDate = getSetting('general_subscription_settings_max_date_handling');

	if (maxDate === 'no') {
		return false;
	}

	const {interval, period} = wp.data.select(STORE_NAME).getSubscriptionData();

	const date = new Date();
	switch (period) {
		case 'day':
			date.setDate(date.getDate() + 1 * parseInt(interval));
			return date;
		case 'week':
			date.setDate(date.getDate() + 7 * parseInt(interval));
			return date;
		case 'month':
			date.setMonth(date.getMonth() + parseInt(interval));
			return date;
		case 'year':
			date.setFullYear(date.getFullYear() + parseInt(interval));
			return date;
	}
}
